import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import cn from "classnames";
import styles from "./styles.module.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";

export const ServiceDifferential = ({
  title,
  subtitle,
  top = [],
  left = [],
  row1 = [],
  row2 = [],
  row3 = [],
  className,
}) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 992);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  const allCards = [...(row1 || []), ...(row2 || []), ...(row3 || [])].slice(0, 15);

  const renderCard = (item, idx, propPrefix) => (
    <SwiperSlide key={`${propPrefix}[${idx}].text`} className={styles.swiperSlide}>
      <div className={styles.whiteCard} data-sourceflow-prop={`${propPrefix}[${idx}].text`}>
        {item?.text}
      </div>
    </SwiperSlide>
  );

  return (
    <section className={cn(styles.ServiceDifferential, className)}>
      <Container className={styles.inner}>
        <div className={styles.header}>
          {subtitle && (
            <p className={styles.subtitle} data-sourceflow-prop="subtitle">
              {subtitle}
            </p>
          )}
          {title && (
            <h2 className={styles.title} data-sourceflow-prop="title">
              {title}
            </h2>
          )}
        </div>

        <div className={styles.grid}>
          {isMobile ? (
            <Swiper slidesPerView={"auto"} spaceBetween={16} freeMode={true} className={styles.mobileSwiper}>
              {allCards.map((item, idx) => renderCard(item, idx, `card${idx}`))}
            </Swiper>
          ) : (
            <>
              <div className={styles["row--headers"]}>
                {top.map((item, idx) => (
                  <div
                    key={`top-${idx}`}
                    className={styles.pill}
                    style={{ backgroundColor: item?.background }}
                    data-sourceflow-prop={`top[${idx}].label`}
                  >
                    {item?.label}
                  </div>
                ))}
              </div>
              {[row1, row2, row3].map((row, i) => (
                <React.Fragment key={`row-${i}`}>
                  <div className={styles.rail}>
                    <div
                      className={styles.railCard}
                      style={{ backgroundColor: left[i]?.background }}
                      data-sourceflow-prop={`left[${i}].label`}
                    >
                      {left[i]?.label}
                    </div>
                  </div>
                  <div className={styles["row--content"]}>
                    {row?.slice(0, 5).map((item, idx) => (
                      <div
                        key={`row${i + 1}-${idx}`}
                        className={styles.whiteCard}
                        data-sourceflow-prop={`row${i + 1}[${idx}].text`}
                      >
                        {item?.text}
                      </div>
                    ))}
                  </div>
                </React.Fragment>
              ))}
            </>
          )}
        </div>
      </Container>
    </section>
  );
};

export default ServiceDifferential;
